import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/app/ui/assets/svg/cod-red.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-30501a4c")

_pushScopeId("data-v-30501a4c")
const _hoisted_1 = { class: "balance-list pt-8 bg-white flex flex-col text-12px xxl:text-14px overflow-hidden h-screen relative w-full font-montserrat" }
const _hoisted_2 = { class: "mb-2 font-semibold text-20px mr-4 whitespace-no-wrap text-black-lp-200 capitalize" }
const _hoisted_3 = { class: "w-full px-1 pt-8 flex flex-col gap-y-8 mb-8 border-t border-gray-lp-200" }
const _hoisted_4 = { class: "flex flex-col w-full gap-y-2 px-4 py-3 shadow-balance border border-gray-lp-900 rounded-lg" }
const _hoisted_5 = { class: "font-montserrat font-normal text-12px xxl:text-14px text-black-lp-300" }
const _hoisted_6 = { class: "flex flex-row w-full text-24px font-semibold font-montserrat text-black-lp-300" }
const _hoisted_7 = { class: "flex flex-row w-1/2 gap-x-3 items-center" }
const _hoisted_8 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-10 max-w-none",
  alt: "cod-red"
}, null, -1)
const _hoisted_9 = { "data-testid": "cod-income-header-balance" }
const _hoisted_10 = { class: "flex flex-row justify-end w-1/2 gap-x-3 items-center" }
const _hoisted_11 = { class: "flex flex-row items-center gap-4 flex-no-wrap relative" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Header = _resolveComponent("Header")!
  const _component_lp_button = _resolveComponent("lp-button")!
  const _component_Search = _resolveComponent("Search")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_time_range_picker = _resolveComponent("time-range-picker")!
  const _component_EmptyState = _resolveComponent("EmptyState")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_modal_withdraw = _resolveComponent("modal-withdraw")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_Breadcrumb),
      _createVNode(_component_Header, { class: "items-center" }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_2, _toDisplayString(_ctx.$t("codIncome.title")), 1)
        ]),
        _: 1
      }),
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("codIncome.title")), 1),
          _createVNode("div", _hoisted_6, [
            _createVNode("div", _hoisted_7, [
              _hoisted_8,
              _createVNode("p", _hoisted_9, _toDisplayString(_ctx.codIncome), 1)
            ]),
            _createVNode("div", _hoisted_10, [
              (_ctx.isVisibleViewDetail)
                ? (_openBlock(), _createBlock(_component_lp_button, {
                    key: 0,
                    title: "",
                    textColor: "white",
                    iconLeft: _ctx.isDisableWithdraw ? 'withdraw-gray' : 'withdraw-red',
                    onClick: _ctx.goToWithdraw,
                    outline: "",
                    disabled: _ctx.isDisableWithdraw
                  }, null, 8, ["iconLeft", "onClick", "disabled"]))
                : _createCommentVNode("", true)
            ])
          ])
        ]),
        _createVNode("div", _hoisted_11, [
          _createVNode(_component_Search, {
            onInput: _ctx.onSearch,
            onClear: _ctx.clearSearch,
            value: _ctx.search,
            placeholder: _ctx.$t('codIncome.search'),
            class: "flex flex-row items-center w-3/12",
            style: {"margin-right":"0"}
          }, null, 8, ["onInput", "onClear", "value", "placeholder"]),
          _createVNode(_component_CustomDropdown, {
            isExpand: _ctx.isOpenSelect,
            "onUpdate:isExpand": _cache[1] || (_cache[1] = ($event: any) => (_ctx.isOpenSelect = $event)),
            options: _ctx.options,
            onSelect: _ctx.onSelect,
            placeholder: _ctx.$t('codIncome.filter'),
            class: `select-status ${_ctx.isOpenSelect ? 'w-56' : ''}`,
            isCustomWidth: "",
            isCustomMaxHeight: "",
            selectedItem: _ctx.advancedFilterData.type
          }, null, 8, ["isExpand", "options", "onSelect", "placeholder", "class", "selectedItem"]),
          _createVNode(_component_time_range_picker, {
            default: _ctx.$t('7 hari terakhir'),
            class: "mr-4",
            startDate: _ctx.startDate,
            "onUpdate:startDate": _cache[2] || (_cache[2] = ($event: any) => (_ctx.startDate = $event)),
            endDate: _ctx.endDate,
            "onUpdate:endDate": _cache[3] || (_cache[3] = ($event: any) => (_ctx.endDate = $event)),
            onSelect: _ctx.setDateRange,
            style: {"margin-right":"0"},
            minDate: _ctx.minDate,
            maxDate: _ctx.maxDate,
            onDayClick: _ctx.setDay,
            onCancelRangePick: _ctx.cancelRangePick,
            showOptions: 
            `${_ctx.$t('custom')}, ${_ctx.$t('hari ini')}, ${_ctx.$t('kemarin')}, ${_ctx.$t(
              '7 hari terakhir'
            )}, ${_ctx.$t('30 hari terakhir')}`
          ,
            isOptionDisabled: !_ctx.isStartDate
          }, null, 8, ["default", "startDate", "endDate", "onSelect", "minDate", "maxDate", "onDayClick", "onCancelRangePick", "showOptions", "isOptionDisabled"]),
          _createVNode(_component_lp_button, {
            class: "download-mutasi absolute inset-y-0 right-0",
            title: _ctx.$t('codIncome.downloadStatement'),
            textColor: "black-lp-300",
            color: "gray-lp-600",
            icon: "download-gray",
            onClick: _ctx.exportCod,
            disabled: false,
            outline: ""
          }, null, 8, ["title", "onClick"])
        ])
      ]),
      (
        _ctx.codIncomeList.length === 0 &&
          !_ctx.startDate &&
          !_ctx.endDate &&
          !_ctx.isLoading &&
          !_ctx.search &&
          !_ctx.advancedFilterData.type.value
      )
        ? (_openBlock(), _createBlock(_component_EmptyState, {
            key: 0,
            customMessage: _ctx.$t('Oops.. Belum ada data yang dapat ditampilkan')
          }, null, 8, ["customMessage"]))
        : (_openBlock(), _createBlock(_component_TableV2, {
            key: 1,
            columns: _ctx.columns,
            data: _ctx.codIncomeList,
            loading: _ctx.isLoading,
            pagination: _ctx.pagination,
            "onUpdate:pagination": _cache[4] || (_cache[4] = ($event: any) => (_ctx.pagination = $event)),
            totalColumnFreeze: 1,
            isRightFreeze: true,
            pinnedSubstractHeight: "452px",
            onRequest: _ctx.fetchCodIncomeList,
            "error-cause": _ctx.errorCause,
            shadowYStart: "370",
            showRightShadow: "",
            autoHeight: ""
          }, null, 8, ["columns", "data", "loading", "pagination", "onRequest", "error-cause"]))
    ]),
    (_ctx.isOpenModalWithdraw)
      ? (_openBlock(), _createBlock(_component_modal_withdraw, {
          key: 0,
          "balance-type": "cod",
          onClose: _ctx.closeModalWithdraw
        }, null, 8, ["onClose"]))
      : _createCommentVNode("", true)
  ], 64))
})